/**
 * Enum of RowStatus, each one represent a value according to Service contract
 */
export class RowStatus {
  public static PROCESSED = 'A';
  public static DISCARDED = 'DS';
  public static FAILED = 'EC';
  public static WAITING = 'WT';
  public static DISCARDED_LEGACY = 'R';
  public static FAILED_LEGACY = 'F';
}
